import {ChangeDetectorRef, Component, OnDestroy, OnInit,Input,OnChanges,ChangeDetectionStrategy,ApplicationRef } from '@angular/core';
import { FormGroup, FormBuilder,Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {AuthService} from "../services/auth/AuthService";
import {UserVM} from "../models/UserVM";
import {LoginVM} from "../models/LoginVM";
import {AlertService} from "../services/alert/alert.service";
import {Subscription} from "rxjs";
import {TimerObservable} from "rxjs/observable/TimerObservable";
import {CacheUtilService} from "../services/cache-util/CacheUtilService";
import {AuthGuard} from "../services/auth/AuthGuard";
import {CompanyService} from "../services/company-service/company-service";



//import {trigger,state,style,animate,transition} from '@angular/animations';

declare var smartWizardRef:any;


@Component({
  selector: 'reset-password',
  template: require('./reset-password.component.html'),
  styles: [require('./reset-password.style.css')],
  //animations: [
  //  trigger('stepState', [
  //    state('inactive', style({
  //      backgroundColor: '#eee',
  //      transform: 'scale(1)'
  //    })),
  //    state('active',   style({
  //      backgroundColor: '#cfd8dc',
  //      transform: 'scale(1.1)'
  //    })),
  //    transition('inactive => active', animate('100ms ease-in')),
  //    transition('active => inactive', animate('100ms ease-out'))
  //  ])
  //]
  providers: [AuthService]

})

export class ResetPasswordComponent implements OnDestroy, OnInit,OnChanges {

  public id;
  public baseurl:string = '';
  public doNotMatch  ;
  public error;
  public errorUserExists;
  public success;
  public errorEmailExists;
  public phoneNumberExists;
  public registerAccount;
  public confirmPassword;
  public step=1;
  public previousUrl;
  private tick: number=60;
  private canResendMessage=false;
  private subscription: Subscription;
  keyUrl = "";


  constructor(private ref:ChangeDetectorRef,
              public route:ActivatedRoute,
              public router:Router,
              private authService:AuthService,
              private alertService:AlertService,
              private cacheUtil:CacheUtilService,
              private authGuard:AuthGuard,
              private fb:FormBuilder,
              private companyService: CompanyService
  ) {


    this.doNotMatch = null;
    this.error = null;
    this.errorUserExists = null;
    this.success = null;
    this.registerAccount=new UserVM();


  }

  getState(stepNumber)
  {
    if(this.step==stepNumber)return "active";
    else return "inactive";
  }
  sendActivationCode()
  {
    let parent=this;


     this.authService.sendActivationCodeToResetPassword(parent.registerAccount.phoneNumber,this.keyUrl).then(function () {
    parent.step=2;
       parent.registerAccount.activationCode="";
       parent.registerAccount.password='';
       parent.startTimer();
     //  alert('done');
     }).catch(function (response) {
  // alert('error');

     });
      return false;

  }
  doAfterRegister(

  ) {

    this.login();

  }
  doAfterSuccessLogin() {

    this.alertService.showSuccessMessage('global.messages.info.SuccessfulLogin');


  }
  login() {
    this.authGuard.openLoginDialog();
    //
    //
    //  let credential:LoginVM = new LoginVM();
    //  credential.userName = this.registerAccount.phoneNumber;
    //  credential.password = this.registerAccount.password;
    //  credential.rememberMe = true;
    //
    //  let parent = this;
    //  this.error = null;
    //  this.authService.login(credential) .then(function (data) {
    //      parent.cacheUtil.storeInCache("jhi-authenticationToken", data);
    //
    //
    //      parent.authService.loggedIn().then((res)=> {
    //        parent.authService.updateLoginStatus();
    //        parent.doAfterSuccessLogin();
    //      });
    //
    //    })
    //    .catch(function (err) {
    //      parent.alertService.showErrorMessage('global.messages.error.failedLogin');
    //    });
    //  ;
    }

  confirmActivationCode()
  {
    let parent=this;
    let passwordDTO=new UserVM();
    passwordDTO.password=parent.registerAccount.password;
    passwordDTO.phoneNumber=parent.registerAccount.phoneNumber;
    passwordDTO.verificationCode=parent.registerAccount.activationCode;

    this.authService.resetPassword(passwordDTO).then(function () {
   parent.passwordResetDone();
      //  alert('done');
    }).catch(function (response) {
  //    parent.passwordResetDone();
      //alert('error');

    });
  }
  passwordResetDone()
  {

    let parent=this;
    this.alertService.showSuccessMessage('msg.password_reset_done');
  //  this.doAfterRegister();
    parent.router.navigateByUrl('/home');
    //if(this.previousUrl)
    //{
    //  this.router.navigateByUrl(this.previousUrl);
    //}
    //else {
    //
    //}

  }
  resendActivationCode()
  {
    this.step=1;
  }

  startTimer()
  {
    if(this.subscription)
      this.subscription.unsubscribe();
    let parent=this;
    this.canResendMessage=false;
    this.tick=60;
    let timer = TimerObservable.create(2000, 1000);
    this.subscription = timer.subscribe(t => {
      if(this.tick>0) {
        this.tick = this.tick - 1;
      }else {
        this.canResendMessage = true;
      }
    });
  }




  //ngOnDestroy():void {
  //}

  ngOnInit():void {
    this.route.params.subscribe((p)=>{
      this.baseurl=p['baseurl'];
    //  this.loadWizard();
    })

    this.getCompanyInfo();

  }

  ngOnChanges(changes):void {
  }
  ngOnDestroy() {
    if(this.subscription)
      this.subscription.unsubscribe();
  }

  getCompanyInfo() : void {
    let parent = this;

    this.companyService.getCompanyInfo().subscribe((c) => {
      if(c && c.keyUrl)
        parent.keyUrl = c.keyUrl;
    })
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/reset-password/reset-password.component.ts